<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetAccountList' }">预算科目</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="code：">
                                    <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="所有人："> </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="名称：">
                                    <el-input v-model="list.name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：">
                                    <el-input v-model="list.status_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="标签：">
                                    <el-input v-model="list.label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算科目类型：">
                                    <el-input v-model="list.type_label" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算对象：">
                                    <div class="read_only read_only_link">
                                        <span @click="mainClick(list.budget_object_rid)">{{ list.budget_object_full_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="部门：">
                                    <div class="read_only read_only_link">
                                        <span @click="departmentClick(list.department_rid)">{{ list.department_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="辅助类型：">
                                    <el-input
                                        v-model="list.assistance_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item v-if="list.assistance == 3" label="合作往来类型：">
                                    <el-input
                                        v-model="list.deal_type_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="负责人：">
                                    <div class="read_only read_only_link">
                                        <span @click="principalClick(list.principal_rid)">{{ list.principal_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="会计属性：">
                                    <el-input
                                        v-model="list.accounting_attribute_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="备注：">
                                    <el-input v-model="list.remark" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <div class="space"></div>
                                <el-form-item label="部门编码：">
                                    <el-input
                                        v-model="list.department_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="budget_object_rid：">
                                    <el-input
                                        v-model="list.budget_object_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="负责人工号：">
                                    <el-input
                                        v-model="list.principal_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="department_rid：">
                                    <el-input
                                        v-model="list.department_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="principal_rid：">
                                    <el-input
                                        v-model="list.principal_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div class="space"></div>
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="预算项目" name="1">
                    <vBudgetItemList :postList="postList" v-if="flag"></vBudgetItemList>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vBudgetItemList from '../../listComponent/budget/budgetList/budgetItemListComponent.vue';
export default {
    inject: ['reload'],
    name: 'budgetAccountDetails',
    components: {
        vBudgetItemList
    },
    data() {
        return {
            headerTitle: '预算科目详情',
            list: {},
            activeNames: ['1'],
            rid: '',
            //预算项目列表传参控制显示隐藏
            postList: {
                params: {
                    budget_subject_rid: '', // 预算科目
                    budget_subject_rid_show: ''
                },
                headerTitle: false,
                code: false,
                name: false,
                period: false,
                timeliness: false,
                status: false,
                control: false,
                beneficiary_rid: false,
                principal_rid: false,
                project_rid: false,
                department_rid: false,
                budget_subject_rid: false,
                control_scope: false,
                addBtn: false,
                searchBtn: false,
                resetBtn: false,
                downFileBtn: false,
                setBtn: true
            },
            flag: true
        };
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.reload();
        }
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.getDetails(); //获取详情
    },
    methods: {
        //负责人查看
        principalClick(rid) {
            this.$router.push({
                path: '/personDetail',
                query: {
                    id: rid
                }
            });
        },
        mainClick(rid) {
            this.$router.push({
                path: '/budgetObjectDetails',
                query: {
                    id: rid
                }
            });
        },
        //部门查看
        departmentClick(rid) {
            this.$router.push({
                path: '/departmentDetails',
                query: {
                    id: rid
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetSubjectDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/budgetAccountList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'budgetAccountEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'budgetAccountEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'budgetAccountEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetAccountList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetSubjectDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        document.title = this.headerTitle + ':' + res.data.code;
                        this.postList.params.budget_subject_rid = res.data.rid;
                        this.flag = false;
                        this.$nextTick(() => {
                            this.flag = true;
                        });
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>